export default "__VITE_ASSET__929fe103__"